import { getDefaultConfig } from '@rainbow-me/rainbowkit';
import { base, mainnet } from 'wagmi/chains';
import { Config } from 'wagmi';

export const config: Config = getDefaultConfig({
  appName: 'Velora Token Distribution',
  projectId: '5b56c06b693e6dd2d36d8cf9ead178e5', // You can get this from https://cloud.walletconnect.com
  chains: [mainnet, base],
  ssr: false,
});
